import { images } from "../../assets/images";
import { useDispatch } from "react-redux";
import { getOrganizerCurrency } from "../../utils/currency";
import { fetchOrganizersThunk } from "../../store/organizer/thunks";
import { AppDispatch } from "../../store/store";
import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { getReport } from "../../api";
import { ColumnDef } from "@tanstack/react-table";
import { TablesV2 } from "../../components/common/Tables/TablesV2";
import { Link, useParams, useLocation } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import Background from "../Login/Background";
import { useNightMode } from "../../contexts/NightModeContext";
import QRCode from "qrcode";

type Props = {};

const EventHomePage = (props: Props) => {
  const { eventId } = useParams();
  const location = useLocation();
  const backTarget = (location.state as any)?.from || sessionStorage.getItem("eventNavSource") || "/home";
  const currencySymbol = getOrganizerCurrency().symbol;
  const [urlModalOpen, setUrlModalOpen] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrEventUrl, setQrEventUrl] = useState("");
  const [logoModalOpen, setLogoModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const qrCanvasRef = useRef<HTMLCanvasElement>(null);
  const dispatch: AppDispatch = useDispatch();
  const { isNightMode } = useNightMode();
  const [attendeesList, setAttendeesList] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    totalBookings: 0,
    totalRevenue: 0,
    totalTickets: 0,
    totalAttendees: 0,
    totalTicketsSold: 0,
    totalDiscount: 0
  });
  const [eventInfo, setEventInfo] = useState<{
    eventName: string;
    bannerImg: string;
    thumbImg: string;
    eventDate: string;
    endDate: string;
    eventTime: string;
    endTime: string;
    eventCity: string;
    eventState: string;
    countryName: string;
    venueName: string;
    categoryName: string;
    description: string;
    organizerName: string;
    organizerPic: string;
    isSingleDayEvent?: boolean;
  }>({
    eventName: "",
    bannerImg: "",
    thumbImg: "",
    eventDate: "",
    endDate: "",
    eventTime: "",
    endTime: "",
    eventCity: "",
    eventState: "",
    countryName: "",
    venueName: "",
    categoryName: "",
    description: "",
    organizerName: "",
    organizerPic: "",
    isSingleDayEvent: false,
  });

  useEffect(() => {
    dispatch(fetchOrganizersThunk());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const ev = JSON.parse(eventData);
          const eventSlug = ev.eventId;
          const locationVenue = ev.locationData?.[0]?.venueName || "";
          const { ticketFee, processingFee } = ev;
          let totalEventoxFee = 0;
          let totalStripeFee = 0;
          let totalTicketAmount = 0;
          let totalDiscountAmount = 0;
          let totalTicketSold = 0;
          let totalGrandTotal = 0;
          let totalSuccessBooking = 0;
          let totalOrganizerRevenue = 0;
          const feeCollectedFromOrganizer = processingFee === 0 && ticketFee === 0;

          setEventInfo({
            eventName: ev.eventName || "Unnamed Event",
            bannerImg: ev.bannerImgDesktop || ev.bannerImgMobile || ev.thumbImg || images.defaultProfileIcon,
            thumbImg: ev.thumbImg || images.defaultProfileIcon,
            eventDate: ev.eventDate || "",
            endDate: ev.endDate || "",
            eventTime: ev.eventTime || "",
            endTime: ev.endTime || "",
            eventCity: ev.eventCity || "",
            eventState: ev.eventState || "",
            countryName: ev.Country?.countryName || "",
            venueName: locationVenue,
            categoryName: ev.Category?.categoryName || "",
            description: ev.eventDescription || "",
            organizerName: ev.Organizer?.name || "",
            organizerPic: ev.Organizer?.profilePic || "",
            isSingleDayEvent: !!ev.isSameDayEvent,
          });

          const response = await getReport(eventSlug);
          const data = response.filter((item: any) => item.bookingStatus === 'confirmed');
          setAttendeesList(data);

          data.forEach((item: any) => {
            if (item.bookedBy === '0') {
              let stripefee = 0;
              let eventoxRevenue = 0;
              let organizerRevenue = 0;

              const grandTotal = item.grandTotal;
              const ticketAmount = item.totalTicketAmount;
              const discountAmount = item.discountAmount ? item.discountAmount : 0;
              const ticketCount = item.totalTicketCount;
              if (feeCollectedFromOrganizer) {
                stripefee = ((grandTotal / 100) * 2.7) + 0.30;
                const ticketFee = ticketCount * 0.5;
                const ourFee = ((grandTotal / 100) * 2.5) + (ticketFee);
                if (Number(ticketCount) === 1) {
                  eventoxRevenue = 0;
                } else {
                  eventoxRevenue = Number(ourFee) - Number(stripefee);
                }
                organizerRevenue = grandTotal - stripefee - eventoxRevenue - discountAmount;
              } else {
                if (item.stripeRevenue === null) {
                  stripefee = ((grandTotal / 100) * 2.7) + 0.30;
                } else {
                  stripefee = item.stripeRevenue;
                }
                if (item.eventoxRevenue === null) {
                  eventoxRevenue = grandTotal - stripefee - ticketAmount;
                } else {
                  eventoxRevenue = item.eventoxRevenue;
                }
                if (item.organizerRevenue === null) {
                  organizerRevenue = (ticketAmount - stripefee - eventoxRevenue - discountAmount);
                } else {
                  organizerRevenue = item.organizerRevenue;
                }
              }

              totalStripeFee += Number(stripefee);
              totalEventoxFee += Number(eventoxRevenue);
              totalTicketAmount += Number(ticketAmount);
              totalDiscountAmount += Number(discountAmount);
              totalTicketSold += Number(item?.totalTicketCount);
              totalGrandTotal += Number(grandTotal);
              totalOrganizerRevenue += Number(organizerRevenue);
              totalSuccessBooking += 1;
            }
          });

          setDashboardData({
            totalBookings: totalSuccessBooking,
            totalRevenue: totalOrganizerRevenue,
            totalTickets: totalTicketSold,
            totalAttendees: 0,
            totalTicketsSold: totalTicketSold,
            totalDiscount: totalDiscountAmount
          });
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(selectedUrl);
      toast.success("Copied to clipboard!");
      setUrlModalOpen(false);
    } catch {
      toast.error("Copy failed");
    }
  };

  const handleNavigate = () => {
    window.open(selectedUrl, "_blank");
    setUrlModalOpen(false);
  };

  const generateQrOnCanvas = useCallback(async (url: string) => {
    if (!qrCanvasRef.current || !url) return;
    try {
      await QRCode.toCanvas(qrCanvasRef.current, url, {
        width: 280,
        margin: 2,
        color: {
          dark: "#0f172a",
          light: "#ffffff",
        },
      });
    } catch (err) {
      console.error("QR generation failed:", err);
    }
  }, []);

  const handleOpenQrModal = () => {
    const eventData = localStorage.getItem("eventData");
    const slugId = eventData ? JSON.parse(eventData).slugId : "";
    const fullUrl = slugId ? `https://eventox.co/event/${slugId}` : window.location.href;
    setQrEventUrl(fullUrl);
    setSelectedUrl(fullUrl);
    setQrModalOpen(true);
  };

  const handleDownloadQr = () => {
    const canvas = qrCanvasRef.current;
    if (!canvas) { toast.error("QR canvas not ready"); return; }
    try {
      canvas.toBlob((blob) => {
        if (!blob) { toast.error("Failed to generate QR image"); return; }
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        const sanitizeName = eventInfo.eventName
          ? eventInfo.eventName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
          : "event";
        link.download = `eventox-qr-${sanitizeName}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        toast.success("QR Code downloaded!");
      }, "image/png");
    } catch (err) {
      toast.error("Download failed — try right-clicking the QR image to save.");
    }
  };

  const handleDownloadLogo = async (logoSrc: string, fileName: string) => {
    try {
      const response = await fetch(logoSrc);
      if (!response.ok) throw new Error("fetch failed");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      toast.success(`${fileName} downloaded!`);
    } catch {
      // Fallback: direct href download
      const link = document.createElement("a");
      link.href = logoSrc;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`${fileName} downloaded!`);
    }
  };

  const filteredAttendees = attendeesList.filter(att => {
    const firstName = att.Contact?.firstName || att.firstName || "";
    const lastName = att.Contact?.lastName || att.lastName || "";
    const name = [firstName, lastName].filter(Boolean).join(" ") || att.name || "Customer";
    const email = att.Contact?.email || att.email || "";
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return name.toLowerCase().includes(q) || email.toLowerCase().includes(q);
  });

  const toggleCheckIn = (bookingId: string, idx: number) => {
    setAttendeesList(prev =>
      prev.map((item, i) =>
        (item.bookingId === bookingId && bookingId) || i === idx
          ? { ...item, checkIn: !item.checkIn }
          : item
      )
    );
    toast.success("Check-in status updated!");
  };

  const attendeeColumns = useMemo<ColumnDef<any, any>[]>(() => [
    {
      header: "Attendee Name",
      accessorFn: (row) => {
        const fn = row.Contact?.firstName || row.firstName || "";
        const ln = row.Contact?.lastName || row.lastName || "";
        return [fn, ln].filter(Boolean).join(" ") || row.name || "Customer";
      },
      id: "name",
      cell: (info) => <span className={`fw-bold ${isNightMode ? 'text-white' : 'text-dark'}`}>{info.getValue()}</span>,
    },
    {
      header: "Email",
      accessorFn: (row) => row.Contact?.email || row.email || "—",
      id: "email",
      cell: (info) => <span className="font-mono" style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.65)" : "#334155" }}>{info.getValue()}</span>,
    },
    {
      header: "Ticket Type",
      accessorFn: (row) => row.TicketType?.ticketType || "—",
      id: "ticketType",
      cell: (info) => <span style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.7)" : "#334155" }}>{info.getValue()}</span>,
    },
    {
      header: "Tickets",
      accessorKey: "totalTicketCount",
      cell: (info) => <span className={isNightMode ? 'text-white' : 'text-dark'}>{info.getValue() || 1}</span>,
    },
    {
      header: "Amount Paid",
      accessorKey: "grandTotal",
      cell: (info) => (
        <span className="fw-bold font-mono" style={{ color: "#18C37E" }}>
          {currencySymbol} {Number(info.getValue() || 0).toFixed(2)}
        </span>
      ),
    },
    {
      header: "Date",
      accessorKey: "createdAt",
      cell: (info) => (
        <span className="font-mono" style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.5)" : "#64748B" }}>
          {info.getValue() ? new Date(info.getValue()).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "N/A"}
        </span>
      ),
    },
    {
      header: "Check-In",
      id: "checkIn",
      cell: ({ row }) => {
        const att = row.original;
        const checked = att.checkIn;
        return (
          <button
            onClick={() => toggleCheckIn(att.bookingId, row.index)}
            className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase"
            style={{
              fontSize: 10,
              letterSpacing: "0.08em",
              height: 28,
              padding: "2px 10px",
              borderRadius: 8,
              cursor: "pointer",
              transition: "all 0.2s",
              ...(checked
                ? { background: "rgba(24,195,126,0.1)", border: "1px solid rgba(24,195,126,0.3)", color: "#18C37E" }
                : { background: isNightMode ? "rgba(255,255,255,0.05)" : "#f1f5f9", border: isNightMode ? "1px solid rgba(255,255,255,0.08)" : "1px solid #cbd5e1", color: isNightMode ? "rgba(255,255,255,0.45)" : "#475569" })
            }}
          >
            {checked
              ? <><i className="fa-solid fa-circle-check"></i> Checked In</>
              : <><i className="fa-solid fa-circle-xmark"></i> Not Checked</>}
          </button>
        );
      },
    },
  ], [currencySymbol, attendeesList, isNightMode]);

  const displayedAttendees = showAll ? filteredAttendees : filteredAttendees.slice(0, 5);

  return (
    <div
      className={`eventox-dashboard position-relative ${isNightMode ? 'text-white' : 'text-dark'} dashboard-mobile-offset`}
      style={{ zIndex: 5, overflowX: "hidden", width: "100%" }}
    >
      <Background />
      <ToastContainer autoClose={1500} />
      <div className="position-relative py-3 eventox-container d-flex flex-column gap-4" style={{ zIndex: 10, maxWidth: 1440, margin: "0 auto", width: "100%" }}>

        {/* Back & Status Bar */}
        <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3 pb-4" style={{ borderBottom: isNightMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #e2e8f0" }}>
          <Link
            to={backTarget}
            className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase"
            style={{ fontSize: 12, letterSpacing: "0.08em", textDecoration: "none", color: isNightMode ? "rgba(255,255,255,0.5)" : "#1e293b", background: isNightMode ? "rgba(255,255,255,0.05)" : "#f1f5f9", border: isNightMode ? "1px solid rgba(255,255,255,0.07)" : "1px solid #cbd5e1", borderRadius: 12, padding: "8px 16px" }}
          >
            <i className="fa-solid fa-arrow-left"></i> Back to Workspace
          </Link>
          <div className="d-flex align-items-center gap-2">
            <span className="font-mono text-uppercase" style={{ fontSize: 10, letterSpacing: "0.1em", color: isNightMode ? "rgba(255,255,255,0.4)" : "#64748b" }}>Console Status:</span>
            <span className="font-mono fw-semibold" style={{ fontSize: 12, color: isNightMode ? "#fff" : "#0f172a", background: isNightMode ? "rgba(255,255,255,0.08)" : "#f1f5f9", border: isNightMode ? "1px solid rgba(255,255,255,0.1)" : "1px solid #cbd5e1", borderRadius: 10, padding: "5px 14px" }}>
              {isLoading ? "Loading..." : "Active Workspace"}
            </span>
          </div>
        </div>

        {/* Hero Poster Banner */}
        <div className="position-relative overflow-hidden" style={{ minHeight: 260, borderRadius: 28, border: "1px solid rgba(255,255,255,0.06)", boxShadow: "0 24px 64px rgba(0,0,0,0.5)" }}>
          <div className="position-absolute top-0 start-0 w-100 h-100">
            <img
              src={eventInfo.bannerImg}
              alt={eventInfo.eventName}
              style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.4)" }}
            />
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "linear-gradient(to top, #060609 0%, rgba(6,6,9,0.55) 45%, transparent 100%)" }} />
          </div>
          <div className="position-relative d-flex flex-column justify-content-end p-4 p-md-5" style={{ zIndex: 10, minHeight: 260 }}>
            {eventInfo.categoryName && (
              <span className="font-mono fw-bold text-uppercase text-white d-inline-block mb-2" style={{ fontSize: 9, letterSpacing: "0.14em", background: "linear-gradient(135deg,#EE3F7C,#F79B59)", borderRadius: 999, padding: "4px 12px", width: "fit-content", border: "1px solid rgba(255,255,255,0.12)" }}>
                {eventInfo.categoryName}
              </span>
            )}
            <h1 className="text-white fw-bold mb-2" style={{ fontSize: "clamp(22px, 4vw, 38px)", lineHeight: 1.2, letterSpacing: "-0.01em" }}>
              {eventInfo.eventName}
            </h1>
            <div className="d-flex flex-wrap align-items-center gap-3 font-mono" style={{ fontSize: 12, color: "rgba(255,255,255,0.65)" }}>
              {eventInfo.eventDate && (
                <span className="d-inline-flex align-items-center gap-2">
                  <i className="fa-regular fa-calendar" style={{ color: "#F79B59" }}></i>
                  {(() => {
                    const fmt = (s: string) => {
                      const d = new Date(s + "T00:00:00");
                      return `${d.toLocaleDateString("en-US", { weekday: "short" })}, ${d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}`;
                    };
                    return eventInfo.eventDate === eventInfo.endDate
                      ? fmt(eventInfo.eventDate)
                      : `${fmt(eventInfo.eventDate)} – ${fmt(eventInfo.endDate)}`;
                  })()}
                </span>
              )}
              {(eventInfo.eventTime || eventInfo.endTime) && (
                <span className="d-inline-flex align-items-center gap-2">
                  <i className="fa-regular fa-clock" style={{ color: "#F79B59" }}></i>
                  {[eventInfo.eventTime, eventInfo.endTime].filter(Boolean).join(" – ")}
                </span>
              )}
              {(eventInfo.venueName || eventInfo.eventCity) && (
                <span className="d-inline-flex align-items-center gap-2">
                  <i className="fa-solid fa-location-dot" style={{ color: "#F79B59" }}></i>
                  {[eventInfo.venueName, eventInfo.eventCity, eventInfo.countryName].filter(Boolean).join(", ")}
                </span>
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-3 flex-wrap">
              <button
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase text-white"
                style={{ fontSize: 11, letterSpacing: "0.08em", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10, padding: "6px 14px", cursor: "pointer" }}
                onClick={() => {
                  const eventData = localStorage.getItem("eventData");
                  if (eventData) {
                    const { slugId } = JSON.parse(eventData);
                    setSelectedUrl(`https://eventox.co/event/${slugId}`);
                    setSelectedLabel("Full URL");
                    setUrlModalOpen(true);
                  }
                }}
              >
                <i className="fa-solid fa-link"></i> URL
              </button>
              <button
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase text-white"
                style={{ fontSize: 11, letterSpacing: "0.08em", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10, padding: "6px 14px", cursor: "pointer" }}
                onClick={() => {
                  const eventData = localStorage.getItem("eventData");
                  if (eventData) {
                    const { tinyUrl } = JSON.parse(eventData);
                    setSelectedUrl(`https://eventox.co/tiny/${tinyUrl}`);
                    setSelectedLabel("Tiny URL");
                    setUrlModalOpen(true);
                  }
                }}
              >
                <i className="fa-solid fa-link"></i> Tiny URL
              </button>
              <button
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase text-white"
                style={{ fontSize: 11, letterSpacing: "0.08em", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10, padding: "6px 14px", cursor: "pointer" }}
                onClick={handleOpenQrModal}
              >
                <i className="fa-solid fa-qrcode"></i> Generate QR
              </button>
              <button
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase text-white"
                style={{ fontSize: 11, letterSpacing: "0.08em", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10, padding: "6px 14px", cursor: "pointer" }}
                onClick={() => setLogoModalOpen(true)}
              >
                <i className="fa-solid fa-file-arrow-down"></i> Eventox Logo
              </button>
              <Link
                to={`/event/${eventId || (localStorage.getItem("eventData") ? JSON.parse(localStorage.getItem("eventData")!).eventId : "")}/forum`}
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase text-white"
                style={{
                  fontSize: 11,
                  letterSpacing: "0.08em",
                  background: "linear-gradient(135deg, #EE3F7C, #F79B59)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  borderRadius: 10,
                  padding: "6px 14px",
                  cursor: "pointer",
                  textDecoration: "none"
                }}
              >
                <i className="fa-solid fa-comments"></i> View Enquiries
              </Link>
            </div>
          </div>
        </div>

        {/* Financial & Attendance Boxes */}
        <div>
          <h2 className="fs-11px font-mono text-uppercase ls-2 text-white-40 mb-3">Financial &amp; Attendance Boxes</h2>
          <div className="eventox-stats-grid">
            <Link to="/event/reports/event-revenue-report" style={{ textDecoration: "none" }}>
              <div className="glass-panel eventox-metric-card d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fs-11px text-white-50 text-uppercase ls-1 fw-semibold">Revenue Collected</span>
                    <i className="fa-solid fa-dollar-sign" style={{ color: "#18C37E", fontSize: 14 }}></i>
                  </div>
                  <h3 className="eventox-metric-value fw-bold text-white mb-0 lh-1 font-mono">
                    {currencySymbol} {dashboardData.totalRevenue.toFixed(2)}
                  </h3>
                </div>
                <span className="fs-10px font-mono fw-medium" style={{ color: "#18C37E", marginTop: 8, display: "block" }}>Gross sales collections to date</span>
              </div>
            </Link>

            <Link to="/event/reports/attendee-report" style={{ textDecoration: "none" }}>
              <div className="glass-panel eventox-metric-card d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fs-11px text-white-50 text-uppercase ls-1 fw-semibold">Tickets Sold</span>
                    <i className="fa-solid fa-ticket" style={{ color: "#EE3F7C", fontSize: 14 }}></i>
                  </div>
                  <h3 className="eventox-metric-value fw-bold text-white mb-0 lh-1 font-mono">
                    {dashboardData.totalTicketsSold}
                  </h3>
                </div>
                <span className="fs-10px font-mono fw-medium" style={{ color: "#EE3F7C", marginTop: 8, display: "block" }}>Total tickets purchased</span>
              </div>
            </Link>

            <Link to="/event/reports/booking-status-report" style={{ textDecoration: "none" }}>
              <div className="glass-panel eventox-metric-card d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fs-11px text-white-50 text-uppercase ls-1 fw-semibold">Discounts Claimed</span>
                    <i className="fa-solid fa-tag" style={{ color: "#F79B59", fontSize: 14 }}></i>
                  </div>
                  <h3 className="eventox-metric-value fw-bold text-white mb-0 lh-1 font-mono">
                    {currencySymbol} {dashboardData.totalDiscount.toFixed(2)}
                  </h3>
                </div>
                <span className="fs-10px font-mono fw-medium" style={{ color: "#F79B59", marginTop: 8, display: "block" }}>Savings enjoyed by ticket buyers</span>
              </div>
            </Link>

            <Link to="/event/reports/ticket-report" style={{ textDecoration: "none" }}>
              <div className="glass-panel eventox-metric-card d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fs-11px text-white-50 text-uppercase ls-1 fw-semibold">Total Bookings</span>
                    <i className="fa-solid fa-percent" style={{ color: "#FF5D73", fontSize: 14 }}></i>
                  </div>
                  <h3 className="eventox-metric-value fw-bold text-white mb-0 lh-1 font-mono">
                    {dashboardData.totalBookings}
                  </h3>
                </div>
                <span className="fs-10px font-mono fw-medium" style={{ color: "#FF5D73", marginTop: 8, display: "block" }}>Confirmed booking orders</span>
              </div>
            </Link>

            <Link to={`/event/${eventId || (localStorage.getItem("eventData") ? JSON.parse(localStorage.getItem("eventData")!).eventId : "")}/forum`} style={{ textDecoration: "none" }}>
              <div className="glass-panel eventox-metric-card d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fs-11px text-white-50 text-uppercase ls-1 fw-semibold">Event Enquiries</span>
                    <i className="fa-solid fa-comments" style={{ color: "#3470ca", fontSize: 14 }}></i>
                  </div>
                  <h3 className="eventox-metric-value fw-bold text-white mb-0 lh-1 font-mono" style={{ fontSize: 18 }}>
                    Enquiry Inbox
                  </h3>
                </div>
                <span className="fs-10px font-mono fw-medium" style={{ color: "#3470ca", marginTop: 8, display: "block" }}>Contact-form messages &amp; leads</span>
              </div>
            </Link>
          </div>
        </div>

        {/* About the Event + Event Details sidebar */}
        {eventInfo.description && (
          <div className="d-flex flex-column flex-lg-row gap-4">
            <div className="flex-grow-1 glass-panel" style={{ minWidth: 0 }}>
              <h3 className="v3-section-head mb-3">About the Event</h3>
              <div
                className="font-mono"
                style={{ fontSize: 13, color: isNightMode ? "rgba(255,255,255,0.65)" : "#334155", lineHeight: 1.7 }}
                dangerouslySetInnerHTML={{ __html: eventInfo.description }}
              />
            </div>
            {(eventInfo.organizerName || eventInfo.venueName) && (
              <div className="glass-panel" style={{ width: "100%", maxWidth: 320, flexShrink: 0 }}>
                <h3 className="v3-section-head mb-3">Event Details</h3>
                <div className="d-flex flex-column gap-3">
                  {eventInfo.organizerName && (
                    <div className="d-flex align-items-center gap-3">
                      {eventInfo.organizerPic ? (
                        <img src={eventInfo.organizerPic} alt={eventInfo.organizerName} style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover", border: isNightMode ? "1px solid rgba(255,255,255,0.1)" : "1px solid #e2e8f0" }} />
                      ) : (
                        <div style={{ width: 38, height: 38, borderRadius: "50%", background: "linear-gradient(135deg,#EE3F7C,#F79B59)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "#fff" }}>
                          {eventInfo.organizerName[0]}
                        </div>
                      )}
                      <div>
                        <p className={`mb-0 fw-semibold ${isNightMode ? 'text-white' : 'text-dark'}`} style={{ fontSize: 13 }}>{eventInfo.organizerName}</p>
                        <span className="font-mono text-uppercase" style={{ fontSize: 10, color: isNightMode ? "rgba(255,255,255,0.4)" : "#64748b", letterSpacing: "0.08em" }}>Organizer</span>
                      </div>
                    </div>
                  )}
                  {eventInfo.venueName && (
                    <div className="p-3" style={{ background: isNightMode ? "rgba(255,255,255,0.03)" : "#f8fafc", borderRadius: 12, border: isNightMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #e2e8f0" }}>
                      <span className="font-mono text-uppercase d-block mb-1" style={{ fontSize: 10, color: isNightMode ? "rgba(255,255,255,0.4)" : "#64748b", letterSpacing: "0.08em" }}>Venue</span>
                      <p className={`mb-0 fw-semibold ${isNightMode ? 'text-white' : 'text-dark'}`} style={{ fontSize: 13 }}>{eventInfo.venueName}</p>
                      {(eventInfo.eventCity || eventInfo.eventState) && (
                        <p className="mb-0 font-mono mt-1" style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.45)" : "#64748b" }}>
                          {[eventInfo.eventCity, eventInfo.eventState, eventInfo.countryName].filter(Boolean).join(", ")}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Attendee Insights Console */}
        <div className="glass-panel d-flex flex-column gap-4">
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 pb-3" style={{ borderBottom: isNightMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #e2e8f0" }}>
            <div>
              <h3 className={`mb-1 fw-bold d-flex align-items-center gap-2 ${isNightMode ? 'text-white' : 'text-dark'}`} style={{ fontSize: 14 }}>
                <i className="fa-solid fa-users" style={{ color: "#EE3F7C" }}></i> Attendee Insights Console
              </h3>
              <p className="font-mono mb-0" style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.4)" : "#64748b" }}>
                Total Attendee Roster: {filteredAttendees.length} records
              </p>
            </div>
            <div className="d-flex align-items-center" style={{ background: isNightMode ? "rgba(255,255,255,0.05)" : "#ffffff", border: isNightMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #cbd5e1", borderRadius: 12, padding: "6px 12px" }}>
              <i className="fa-solid fa-magnifying-glass me-2" style={{ fontSize: 12, color: isNightMode ? "rgba(255,255,255,0.4)" : "#64748b" }}></i>
              <input
                type="text"
                placeholder="Search name/email..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ background: "transparent", border: "none", color: isNightMode ? "#fff" : "#0f172a", fontSize: 12, outline: "none" }}
              />
            </div>
          </div>

          <TablesV2
            key={displayedAttendees.length}
            data={displayedAttendees}
            columns={attendeeColumns}
            isLoading={isLoading}
            searchQuery={searchQuery}
            pageSize={Math.max(displayedAttendees.length, 1)}
            emptyMessage="No registration records found matching the filters."
          />
          {filteredAttendees.length > 5 && (
            <div className="d-flex justify-content-center pt-2">
              <button
                onClick={() => setShowAll(v => !v)}
                className="d-inline-flex align-items-center gap-2 font-mono fw-bold text-uppercase"
                style={{ fontSize: 11, letterSpacing: "0.08em", background: isNightMode ? "rgba(255,255,255,0.05)" : "#f1f5f9", border: isNightMode ? "1px solid rgba(255,255,255,0.08)" : "1px solid #cbd5e1", borderRadius: 10, padding: "8px 20px", color: isNightMode ? "rgba(255,255,255,0.6)" : "#475569", cursor: "pointer", transition: "all 0.2s" }}
              >
                {showAll
                  ? <><i className="fa-solid fa-chevron-up"></i> Show Less</>
                  : <><i className="fa-solid fa-chevron-down"></i> Show More ({filteredAttendees.length - 5} more)</>
                }
              </button>
            </div>
          )}
        </div>

        <Modal centered isOpen={urlModalOpen} toggle={() => setUrlModalOpen(false)}>
          <ModalHeader toggle={() => setUrlModalOpen(false)}>{selectedLabel}</ModalHeader>
          <ModalBody className="text-center text-danger">
            What would you like to do with this link?
            <div className="mt-2 text-break text-primary">{selectedUrl}</div>
          </ModalBody>
          <ModalFooter className="justify-content-center">
            <Button color="danger" onClick={handleNavigate}>Open in New Tab</Button>
            <Button color="danger" onClick={handleCopy}>
              <i className="fa-solid fa-share-nodes me-2"></i>
            </Button>
          </ModalFooter>
        </Modal>

        {/* Generate QR Code Modal */}
        <Modal
          centered
          isOpen={qrModalOpen}
          toggle={() => setQrModalOpen(false)}
          className="v3-modal"
          onOpened={() => generateQrOnCanvas(qrEventUrl)}
        >
          <ModalHeader toggle={() => setQrModalOpen(false)}>
            <i className="fa-solid fa-qrcode me-2" style={{ color: "#EE3F7C" }}></i> Event QR Code
          </ModalHeader>
          <ModalBody className="text-center p-4">
            <div className="d-flex flex-column align-items-center gap-3">
              <div
                className="p-3 rounded-3 d-inline-block"
                style={{ background: "#ffffff", border: "1px solid #e2e8f0", boxShadow: "0 4px 24px rgba(0,0,0,0.10)" }}
              >
                <canvas
                  ref={qrCanvasRef}
                  style={{ display: "block", width: 280, height: 280 }}
                />
              </div>
              <p className="mb-0 fw-bold" style={{ fontSize: 14, color: isNightMode ? "#f1f5f9" : "#0f172a" }}>
                {eventInfo.eventName}
              </p>
              <span
                className="font-mono text-break px-2"
                style={{ fontSize: 11, color: isNightMode ? "rgba(255,255,255,0.5)" : "#64748b", maxWidth: 320 }}
              >
                {qrEventUrl}
              </span>
            </div>
          </ModalBody>
          <ModalFooter className="justify-content-center gap-2 flex-wrap">
            <Button
              className="text-white"
              style={{ background: "linear-gradient(135deg, #EE3F7C, #F79B59)", border: "none", borderRadius: 10, fontWeight: 700, padding: "9px 20px", fontSize: 13 }}
              onClick={handleDownloadQr}
            >
              <i className="fa-solid fa-download me-2"></i> Download QR Code (.PNG)
            </Button>
            <Button
              style={{ background: isNightMode ? "rgba(255,255,255,0.1)" : "#f1f5f9", border: isNightMode ? "1px solid rgba(255,255,255,0.15)" : "1px solid #cbd5e1", color: isNightMode ? "#fff" : "#0f172a", borderRadius: 10, fontWeight: 600, padding: "9px 20px", fontSize: 13 }}
              onClick={handleCopy}
            >
              <i className="fa-solid fa-copy me-2"></i> Copy Event Link
            </Button>
          </ModalFooter>
        </Modal>

        {/* Download EventOX Logo Modal */}
        <Modal centered isOpen={logoModalOpen} toggle={() => setLogoModalOpen(false)} className="v3-modal">
          <ModalHeader toggle={() => setLogoModalOpen(false)}>
            <i className="fa-solid fa-file-arrow-down text-orange me-2"></i> Download Eventox Brand Assets
          </ModalHeader>
          <ModalBody className="text-center p-4">
            <p className="fs-13px mb-4" style={{ color: isNightMode ? "rgba(255,255,255,0.7)" : "#475569" }}>
              Download official high-resolution Eventox logos for promotional posters, flyers, and tickets.
            </p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <div className="p-3 rounded-3 border d-flex flex-column align-items-center gap-2" style={{ background: "#ffffff", flex: 1, border: "1px solid #e2e8f0" }}>
                <div className="d-flex align-items-center justify-content-center w-100 p-3 rounded-2" style={{ background: "#ffffff", minHeight: 60 }}>
                  <img src={images.logo} alt="EventOX Official Logo" style={{ maxHeight: 38, maxWidth: "100%", objectFit: "contain" }} />
                </div>
                <span className="fs-11px font-mono fw-semibold mt-1 text-dark">Official Brand Logo</span>
                <Button
                  size="sm"
                  className="w-100 mt-2 text-white"
                  style={{ background: "linear-gradient(135deg, #EE3F7C, #F79B59)", border: "none", borderRadius: 8, fontSize: 11, fontWeight: 700 }}
                  onClick={() => handleDownloadLogo(images.logo, "eventox-official-logo.png")}
                >
                  <i className="fa-solid fa-download me-1"></i> Download Logo
                </Button>
              </div>

              <div className="p-3 rounded-3 border d-flex flex-column align-items-center gap-2" style={{ background: isNightMode ? "rgba(255,255,255,0.03)" : "#1e293b", flex: 1, border: "1px solid rgba(255,255,255,0.1)" }}>
                <div className="d-flex align-items-center justify-content-center w-100 p-3 rounded-2" style={{ background: "#0f172a", minHeight: 60 }}>
                  <img src={images.eventox_dark_logo} alt="EventOX Dark Logo" style={{ maxHeight: 38, maxWidth: "100%", objectFit: "contain" }} />
                </div>
                <span className="fs-11px font-mono fw-semibold mt-1 text-white">Dark Theme Logo</span>
                <Button
                  size="sm"
                  className="w-100 mt-2 text-white"
                  style={{ background: "linear-gradient(135deg, #EE3F7C, #F79B59)", border: "none", borderRadius: 8, fontSize: 11, fontWeight: 700 }}
                  onClick={() => handleDownloadLogo(images.eventox_dark_logo, "eventox-dark-logo.png")}
                >
                  <i className="fa-solid fa-download me-1"></i> Download Logo
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default EventHomePage;
